export const GET_CUSTOMER_DETAILS = 'GET_CUSTOMER_DETAILS'
export const SET_CUSTOMER = 'SET_CUSTOMER'
export const SAVE_CUSTOMER = 'SAVE_CUSTOMER'
export const GET_CUSTOMER_DEBT = 'GET_CUSTOMER_DEBT'
export const CLEAR_CUSTOMER_EMAIL = 'CLEAR_CUSTOMER_EMAIL'
export const SET_CUSTOMER_CONTACT = 'SET_CUSTOMER_CONTACT'
export const CONFIRM_CUSTOMER_BILLING_ADDRESS =
  'CONFIRM_CUSTOMER_BILLING_ADDRESS'
export const SET_MULTI_SITE_DETAILS = 'SET_MULTI_SITE_DETAILS'
export const GET_BANNER_MESSAGES = 'GET_BANNER_MESSAGES'
export const SET_BANNER = 'SET_BANNER'
export const PROCESS_BANNER_MESSAGES = 'PROCESS_BANNER_MESSAGES'
export const UPDATE_TECH_INSTALL_NOTES = 'UPDATE_TECH_INSTALL_NOTES'
export const SET_TECH_INSTALL_NOTES = 'SET_TECH_INSTALL_NOTES'

export function getCustomerDetails(payload) {
  return {
    type: GET_CUSTOMER_DETAILS,
    payload
  }
}

export function setCustomerDetails(details) {
  return {
    type: SET_CUSTOMER,
    payload: {
      details: details
        ? {
            ...details,
            isUpdated: false
          }
        : details
    }
  }
}

export function updateCustomerDetails(details) {
  return {
    type: SET_CUSTOMER,
    payload: {
      details: {
        ...details,
        isUpdated: true
      }
    }
  }
}

export function saveCustomer(customer) {
  return {
    type: SAVE_CUSTOMER,
    payload: { customer }
  }
}

export function clearCustomerEmail() {
  return {
    type: CLEAR_CUSTOMER_EMAIL
  }
}

export function setCustomerContact(contact) {
  return {
    type: SET_CUSTOMER_CONTACT,
    payload: { contact }
  }
}

export function getCustomerDebt(sessionId) {
  return {
    type: GET_CUSTOMER_DEBT,
    payload: { sessionId }
  }
}

export function setCustomerDebt(debt) {
  return {
    type: SET_CUSTOMER,
    payload: { debt }
  }
}

export function getBannerMessages() {
  return {
    type: GET_BANNER_MESSAGES
  }
}

export function setBannerMessages(banner) {
  const { marqueeTiming } = banner
  return {
    type: SET_BANNER,
    payload: {
      banner: {
        marqueeTiming,
        bannerDetails: banner.bannerDetailsResponse
      }
    }
  }
}

export function processBannerInteraction(bannerPayload) {
  return {
    type: PROCESS_BANNER_MESSAGES,
    payload: bannerPayload 
  }
}

export function confirmCustomerBillingAddress(payload) {
  return {
    type: CONFIRM_CUSTOMER_BILLING_ADDRESS,
    payload
  }
}

export function setMultiSiteDetails(payload) {
  return {
    type: SET_MULTI_SITE_DETAILS,
    payload
  }
}

export function updateTechInstallNotes(notes) {
  return {
    type: UPDATE_TECH_INSTALL_NOTES,
    payload: { notes }
  }
}

export function setTechInstallNotes(notes) {
  return {
    type: SET_TECH_INSTALL_NOTES,
    payload: { notes }
  }
}
